export enum FilterMode {
  Chip = 'chip',
  Sidebar = 'sidebar',
  DSP = 'dsp',
}
